import { css } from "@emotion/react";
import { Button, EditModal, Title } from "@src/components";
import React, { useEffect, useState } from "react";
import backArrow from "@src/assets/backArrow.png";
import userNoImage from "@src/assets/userNoImg.png";
import { Common } from "@src/styles/Common";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import EditButton from "@src/components/button/EditButton";
import { useGetUserDetailData } from "@src/hooks/queries/useUserDetail";
import { useApproveExperts, useExpertProfileDetail, useRejectExpert } from "@src/hooks/queries/useExpertDetail";

interface LocationState {
    no?: number;
    from?: "approval" | "user";
}

const ExpertApprovalDetail = () => {
    const navigate = useNavigate();
    const { no } = useParams();
    const location = useLocation();
    const userNo = Number(no);
    const fromApprovalList = (location.state as LocationState)?.from !== "user";

    const [isModalShow, setIsModalShow] = useState(false);
    const { data: user } = useGetUserDetailData(userNo);
    const { data: expert, refetch: expertRefetch } = useExpertProfileDetail(userNo, "userNo");

    const { mutate: approveExperts } = useApproveExperts();
    const { mutate: rejectExpert } = useRejectExpert();

    useEffect(() => {
        expertRefetch();
    }, []);

    return (
        <>
            <div css={detailWrap}>
                <div css={backArrowWrap} onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                    <img src={backArrow} alt="backArrow" width={24} height={24} />
                    <Title title={fromApprovalList ? "매수신청대리인 승인 관리" : "전문가 회원 상세 정보"} />
                </div>
                <div css={detailContentWrap}>
                    <p className="title">기본 정보</p>

                    <div className="content">
                        <div className="contentItem flex">
                            <p className="contentItemTitle">
                                {fromApprovalList ? "승인 상태" : "매수신청대리인 승인 여부"}
                                <span className="contentItemTitleStatus">{expert?.auctionAgentJoinStatus}</span>
                            </p>
                            {expert?.auctionAgentJoinStatus !== "승인완료" && (
                                <>
                                    <Button
                                        color="white"
                                        label="승인 "
                                        size="small"
                                        handleClick={() => {
                                            if (expert?.expertNo) {
                                                approveExperts([expert?.expertNo]);
                                            }
                                        }}
                                    />
                                    {expert?.auctionAgentJoinStatus !== "미승인수정요구" && (
                                        <Button
                                            color="gray"
                                            label="거절 "
                                            size="small"
                                            handleClick={() => {
                                                if (expert?.expertNo) {
                                                    rejectExpert(expert?.expertNo);
                                                }
                                            }}
                                        />
                                    )}
                                </>
                            )}
                        </div>

                        <div className="contentItem">
                            <p className="contentItemTitle">
                                회원 정보
                                <Button
                                    color="gray"
                                    label="회원 정보 수정 "
                                    size="small"
                                    handleClick={() => {
                                        navigate(`/users/update/${user?.userNo}`);
                                    }}
                                />
                            </p>
                            <div className="contentItemTableWrap">
                                <table className="contentItemTable">
                                    <tbody>
                                        <tr>
                                            <td className="label">이름</td>
                                            <td>{user?.userName}</td>
                                            {/* <td className="label">생년월일</td>
                                            <td>{user?.userBirthday}</td> */}
                                        </tr>
                                        <tr>
                                            <td className="label">연락처</td>
                                            <td>{user?.userPhoneNumber}</td>
                                        </tr>
                                        <tr>
                                            <td className="label">이메일</td>
                                            <td>{user?.userEmail}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="contentItem">
                            <p className="contentItemTitle">
                                전문가 정보{" "}
                                <Button
                                    color="gray"
                                    label="전문가 정보 수정 "
                                    size="small"
                                    handleClick={() => {
                                        navigate(`/experts/update/${expert?.expertNo}`);
                                    }}
                                />
                            </p>
                            <div className="flexBox">
                                <div css={expertPreview}>
                                    <div className="profile">
                                        <img
                                            src={
                                                expert?.profileImageUrl === "https://이미지주소"
                                                    ? userNoImage
                                                    : expert?.profileImageUrl
                                            }
                                            alt="user"
                                            width={62}
                                            height={62}
                                        />
                                        <p className="info">
                                            <p className="name">
                                                {expert?.name}
                                                <span className="type">{expert?.typeStr}</span>
                                            </p>
                                            <p className="agency">{expert?.officeName}</p>
                                            <p className="category">
                                                {expert?.hashTags.map((tag) => (
                                                    <span key={tag}>{tag}</span>
                                                ))}
                                            </p>
                                        </p>
                                    </div>

                                    {/* 사무소 정보 */}
                                    <div className="introduction">
                                        <p className="introductionTitle">중개사무소 정보</p>
                                        <p className="introductionContent">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>사무소명</td>
                                                        <td>{expert?.office.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>중개등록번호 </td>
                                                        <td>{expert?.office.registrationNumber}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>대표자</td>
                                                        <td>{expert?.office.ceo}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>전화번호</td>
                                                        <td>{expert?.office.phone}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>소재지</td>
                                                        <td>{expert?.office.address}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </p>
                                    </div>

                                    <div className="introduction">
                                        <p className="introductionTitle">매수신청대리인 등록증</p>
                                        <p className="introductionContent">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <div
                                                            onClick={() => setIsModalShow(true)}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <img
                                                                src={expert?.auctionAgentRegistrationImage}
                                                                alt="매수신청대리인 등록증"
                                                                width={62}
                                                                height={62}
                                                            />
                                                        </div>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </p>
                                    </div>

                                    {/* <div className="introduction">
                                        <p className="introductionTitle">상담내용 및 수수료</p>
                                        <p className="introductionContent">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>경매매물컨설팅</td>
                                                        <td>100만원</td>
                                                    </tr>
                                                    <tr>
                                                        <td>임장동행</td>
                                                        <td>100만원</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </p>
                                    </div> */}

                                    {/* 전문가 정보 */}
                                    <div className="introduction">
                                        <p className="introductionTitle">경력</p>
                                        <p className="introductionContent">
                                            <table>
                                                <tbody>
                                                    {expert?.agentCareer && (
                                                        <tr>
                                                            <td>중개</td>
                                                            <td>{expert?.agentCareer}년</td>
                                                        </tr>
                                                    )}
                                                    {expert?.auctionAgentCareer && (
                                                        <tr>
                                                            <td>매수신청대리인</td>
                                                            <td>{expert?.auctionAgentCareer}년</td>
                                                        </tr>
                                                    )}
                                                    {expert?.consultingCareer && (
                                                        <tr>
                                                            <td>매물컨설팅</td>
                                                            <td>{expert?.consultingCareer}년</td>
                                                        </tr>
                                                    )}
                                                    {expert?.companionCareer && (
                                                        <tr>
                                                            <td>임장동행</td>
                                                            <td>{expert?.companionCareer}년</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </p>
                                    </div>
                                    <div className="introduction">
                                        <p className="introductionTitle">계좌번호</p>
                                        <p className="introductionContent">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>은행</td>
                                                        <td>{expert?.bankName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>계좌번호</td>
                                                        <td>{expert?.bankAccount}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </p>
                                    </div>

                                    {/* 자격 */}
                                    <div className="introduction">
                                        <p className="introductionTitle">자격</p>
                                        <p className="introductionContent">{expert?.qualification}</p>
                                    </div>

                                    {/* 소개 */}
                                    <div className="introduction">
                                        <p className="introductionTitle">소개</p>
                                        <p className="introductionContent">{expert?.intro}</p>
                                    </div>
                                </div>

                                {/* <div className="file">
                                    <div className="label">매수신청대리인 등록증</div>
                                    <div onClick={() => setIsModalShow(true)} style={{ cursor: "pointer" }}>
                                        <img
                                            src={expert?.auctionAgentRegistrationImage}
                                            alt="매수신청대리인 등록증"
                                            width={62}
                                            height={62}
                                        />
                                    </div>
                                </div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditModal
                isModalShow={isModalShow}
                handleBtnClick={() => setIsModalShow(false)}
                handleOpenModal={() => setIsModalShow(false)}
                title="매수신청대리인 등록증"
                size="big"
            >
                <img src={expert?.auctionAgentRegistrationImage} alt="user" width={800} height={1200} />
            </EditModal>
        </>
    );
};

export default ExpertApprovalDetail;

const detailWrap = css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;
`;

const backArrowWrap = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
`;

const detailContentWrap = css`
    margin-top: 36px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid ${Common.colors.gray200};
    border-radius: 4px;

    .title {
        font-size: 16px;
        font-weight: 600;
        background-color: ${Common.colors.purple100};
        padding: 10px;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        justify-content: space-between;
    }
    .content {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 20px;
    }
    .flexBox {
        display: flex;
        flex-direction: row;
        gap: 60px;
        align-items: flex-start;
    }

    .label {
        font-size: 14px;
        font-weight: 600;
        color: ${Common.colors.gray500};
    }

    .account {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        gap: 12px;
    }

    .contentItem {
        position: relative;
        &:not(:first-child) {
            padding-top: 36px;
        }
        .contentItemTableWrap {
            display: flex;
            gap: 12px;
        }

        .file {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-top: 20px;
            .label {
                font-size: 14px;
                font-weight: 600;
                color: ${Common.colors.gray500};
            }
        }
        .contentItemTable {
            margin-top: 12px;
            border-collapse: collapse;
            border-radius: 4px;

            td {
                padding: 10px 10px 10px 0;
                border-radius: 4px;
                min-width: 200px;
            }
            .label {
                min-width: 100px;
                font-size: 14px;
                font-weight: 600;
                color: ${Common.colors.gray500};
            }
        }
    }
    .flex {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
    }
    .contentItemTitle {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        font-size: 14px;
        font-weight: 600;

        .requestDate {
            min-width: 150px;

            font-size: 14px;
            font-weight: 400;
        }
    }
    .contentItemTitleStatus {
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        background-color: ${Common.colors.purple500};
        padding: 8px 12px;
        border-radius: 24px;
        margin-left: 12px;
        margin-right: 12px;
    }
`;

const expertPreview = css`
    margin-top: 12px;
    width: 360px;
    border-radius: 4px;
    border: 1px solid ${Common.colors.gray200};
    padding: 12px 0px;
    .profile {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        padding: 12px;
        .info {
            display: flex;
            flex-direction: column;
            gap: 8px;
            font-weight: 600;
            font-size: 16px;
        }
        .name {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 4px;
        }
        .type {
            font-size: 14px;
            background-color: #a50f00;
            color: #fff;
            padding: 4px 8px;
            font-weight: 400;
            border-radius: 24px;
        }
        .agency {
            font-size: 12px;
            font-weight: 400;
            color: ${Common.colors.gray500};
        }
        .category {
            font-size: 12px;
            font-weight: 400;
            color: #2275ee;
        }
    }
    .introduction {
        margin-top: 12px;
        padding: 12px;
        .introductionTitle {
            background-color: #fff;
            font-size: 16px;
            font-weight: 700;
        }
        .introductionContent {
            background-color: #fff;
            font-size: 14px;
            font-weight: 400;
            padding: 12px 0px;
            line-height: 1.5;

            table {
                width: 100%;
                border-collapse: collapse;
                border-radius: 4px;
            }

            tr {
                > td:first-of-type {
                    width: 100px;
                    padding-right: 12px;
                    color: ${Common.colors.gray500};
                }
                td {
                    padding: 4px 0px;
                    border-bottom: 1px solid ${Common.colors.gray200};
                }
            }
        }
    }
`;
